import React from "react";
import {
  ExclamationCircleFilled,
  WarningFilled,
  CheckCircleFilled,
} from "@ant-design/icons";
import { Card, Tag, Space } from 'antd';
import { NotificationOutlined } from '@ant-design/icons';
import "./traitementToday.scss";

const TraitementToday = ({ traitements = {} }) => {

  // ✅ Récupérer les traitements depuis l'objet
  const ruptures = traitements.ruptures || [];
  const dormants = traitements.dormants || [];
  const recommander = traitements.recommander || [];

  // ✅ Extraire les descriptions des produits (avec produit + marque + taille + couleur)
  const rupturesDescription = ruptures.map(t => 
    `${t.produit || t.nom_produit || 'Produit'} (${t.marque || ''}${t.taille ? ` - T${t.taille}` : ''}${t.couleur ? ` - ${t.couleur}` : ''})`
  ).join(', ');

  const dormantsDescription = dormants.map(t => 
    `${t.produit || t.nom_produit || 'Produit'} (${t.marque || ''}${t.taille ? ` - T${t.taille}` : ''}${t.couleur ? ` - ${t.couleur}` : ''})`
  ).join(', ');

  const recommanderDescription = recommander.map(t => 
    `${t.produit || t.nom_produit || 'Produit'} (${t.marque || ''}${t.taille ? ` - T${t.taille}` : ''}${t.couleur ? ` - ${t.couleur}` : ''})`
  ).join(', ');

  // Définir les actions dynamiquement
  const actions = [
    {
      icon: <ExclamationCircleFilled />,
      title: `${ruptures.length} rupture${ruptures.length > 1 ? 's' : ''} sur modèles rapides`,
      description: rupturesDescription || "Aucune rupture à signaler.",
      type: "danger",
      count: ruptures.length
    },
    {
      icon: <WarningFilled />,
      title: `${dormants.length} stock${dormants.length > 1 ? 's' : ''} dormant${dormants.length > 1 ? 's' : ''}`,
      description: dormantsDescription || "Aucun stock dormant.",
      type: "warning",
      count: dormants.length
    },
    {
      icon: <CheckCircleFilled />,
      title: `${recommander.length} modèle${recommander.length > 1 ? 's' : ''} à recommander`,
      description: recommanderDescription || "Aucun modèle à recommander.",
      type: "success",
      count: recommander.length
    },
  ];

  const filteredActions = actions.filter(action => action.count > 0);
  const totalActions = filteredActions.length;

  const getStatusTag = () => {
    if (totalActions === 0) {
      return <Tag color="success" style={{ fontSize: '11px' }}>Tout est bon</Tag>;
    }
    const hasDanger = filteredActions.some(a => a.type === 'danger');
    const hasWarning = filteredActions.some(a => a.type === 'warning');
    if (hasDanger) {
      return <Tag color="error" style={{ fontSize: '11px' }}>Actions urgentes</Tag>;
    }
    if (hasWarning) {
      return <Tag color="warning" style={{ fontSize: '11px' }}>Actions recommandées</Tag>;
    }
    return <Tag color="default" style={{ fontSize: '11px' }}>Actions à traiter</Tag>;
  };

  return (
    <Card 
      className="traitementToday"
      bordered={false}
      title={
        <Space>
          <NotificationOutlined style={{ fontSize: 18, color: '#1a1a1a' }} />
          <span style={{ fontSize: 15, fontWeight: 600 }}>À traiter aujourd'hui</span>
        </Space>
      }
      extra={getStatusTag()}
    >
      <div className="traitementToday_body">
        {filteredActions.length > 0 ? (
          filteredActions.map((item, index) => (
            <div
              key={index}
              className={`traitementToday_card ${item.type}`}
            >
              <div className="card_icon">{item.icon}</div>
              <div className="card_content">
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>
            </div>
          ))
        ) : (
          <div className="traitementToday_card success">
            <div className="card_icon">
              <CheckCircleFilled />
            </div>
            <div className="card_content">
              <h4>Tout est bon !</h4>
              <p>Aucune action à traiter aujourd'hui.</p>
            </div>
          </div>
        )}
      </div>
    </Card>
  );
};

export default TraitementToday;